export const LISTE_EXERCICE_COMPTABLE = {
  title: 'Liste exercices comptables',
  racine: 'Accueil',
  actions: {
    add: 'Ajouter un exercice comptable',
    export: 'Exporter au format excel',
    search: 'Rechercher',
  },
  tab: {
    code: 'N°',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    etat: 'Etat',
  },
  etat: {
    ouvert: 'Ouvert',
    ferme: 'Fermé',
  },
};

export const ADD_EXERCICE_COMPTABLE = {
  titleAdd: 'Ajouter un exercice comptable',
  titleEdit: 'Modifier un exercice comptable',
  actions: {
    cancel: 'Annuler',
  },
  informationExerciceComptable: {
    title: 'Exercice comptable',
    code: 'N°',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    etat: 'Etat',
  },
  etat: {
    ouvert: 'Ouvert',
    ferme: 'Fermé',
  },
  success: {
    add: 'Exercice comptable ajouté avec succès',
    edit: 'Exercice comptable modifié avec succès',
  },
  error: {
    problemOccured: 'Un problème est survenu',
    dateDebut: 'La date de début est obligatoire',
    dateFin: 'La date de fin est obligatoire',
    dateDebutGreaterdateFin: 'La date début est plus grande que la date de fin',
    code: 'Le n° est obligatoire et il doit faire moins de 6 caractères',
  },
};
